export default String.raw`
{% assign name = include -%}
{% if name == "categoryDescription" -%}
    {% assign isCategoryDescription = true -%}
{% else -%}
    {% assign content = [name].Content-%}
{% endif -%}

{% if content != "" or isCategoryDescription -%}
    <section class="textElement {% if settings.categoryOpenedClosed == 'opened' and isCategoryDescription -%}open clicked{% endif -%}" data-content="{{ content }}">
        <div class="textElement__container">
            {% if isCategoryDescription -%}
                <h3>
                    {% if products.HeaderData.Heading != "" -%}
                        {{products.HeaderData.Heading}}
                    {% else -%}
                        {{page.CurrentSiteNode.Name}}
                    {% endif -%}
                </h3>
                {% if products.HeaderData.Description != "" -%}
                    {{products.HeaderData.Description}}
                {% endif -%}
                {% if products.HeaderData.AiGeneratedDescription -%}
                    <div class="ai-generated-content">{{ translations.AiGeneratedDescription }}</div>
                {% endif -%}
            {% endif -%}
        </div>
        <div class="textElement__gradient"></div>
        <div class="textElement__hidder">
            <button class="textElement__hidder-button">
                <span class="textElement__hidder-button-rollOut rollOut-js">
                    {{ translations.RollOutDescription }}
                </span>
                <span class="textElement__hidder-button-rollIn rollIn-js">
                    {{ translations.RollInDescription }}
                </span>
                <svg>
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                </svg>
            </button>
        </div>
    </section>
{% endif -%}
`